import app from './app';

// russian
export default {
  app,
};
